import { useState, useMemo } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Measure from "react-measure";
import * as pdfjsLib from "pdfjs-dist/webpack.mjs";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

// Configure PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const RenderPDF = ({ pdf_location }) => {
  const [numPages, setNumPages] = useState(0);
  const [width, setWidth] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const onDocumentLoadError = (error) => {
    console.error("Failed to load PDF document:", error);
  };

  // Memoize the file prop
  const memoizedFile = useMemo(() => ({ url: pdf_location }), [pdf_location]);

  return (
    <Measure
      bounds
      onResize={(contentRect) => {
        if (contentRect.bounds) {
          setWidth(contentRect.bounds.width);
        }
      }}
    >
      {({ measureRef }) => (
        <div ref={measureRef}>
          <Document
            file={memoizedFile}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
          >
            {Array.from({ length: numPages }, (_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={width}
              />
            ))}
          </Document>
        </div>
      )}
    </Measure>
  );
};

export default RenderPDF;
